/**
 * product-lp-cart.js
 * Handles the LP product section's variant picker, subscription toggle,
 * and add-to-cart flow. ATC posts to /cart/add.js and goes straight to checkout.
 */

(function () {
  'use strict';

  /* ─── Selectors ─── */
  var SEL = {
    variantBox:       '.variant-check',
    activeBox:        '.variant-check.active',
    subBanner:        '.subscription_new_box',
    subItem:          '.subscription_item',
    subItemSub:       '.subscription_item_sub',
    subTrigger:       '.subscription_trigger',
    priceCell:        '.product_price_custom',
    atcBtn:           '.custom-btn',
  };

  /* ─── Utility: read a data-* attribute via dataset ─── */
  function getAttr(el, name) {
    var camel = name.replace(/-([a-z])/g, function (_, c) { return c.toUpperCase(); });
    return (el.dataset[camel] || '').trim();
  }

  /* ─── Show/hide subscription price rows ─── */
  function setSubMode(isSubscribe) {
    document.querySelectorAll(SEL.subTrigger).forEach(function (el) {
      var tab = el.dataset.tab || '';
      el.style.display = (isSubscribe ? tab === '2' : tab === '1') ? '' : 'none';
    });

    document.querySelectorAll(SEL.subBanner).forEach(function (el) {
      el.classList.toggle('active', isSubscribe);
    });

    document.querySelectorAll(SEL.subItemSub).forEach(function (el) {
      el.classList.toggle('active', isSubscribe);
    });

    // Toggle one-time option (subscription_item that is NOT subscription_item_sub)
    document.querySelectorAll(SEL.subItem + ':not(' + SEL.subItemSub + ')').forEach(function (el) {
      el.classList.toggle('active', !isSubscribe);
    });
  }

  /* ─── Show price cells matching a tab index (scoped to ATC button only) ─── */
  function showPricesForTab(tabIndex) {
    document.querySelectorAll(SEL.atcBtn + ' ' + SEL.priceCell).forEach(function (el) {
      var tab = el.dataset.tab || '';
      el.style.display = (tab === tabIndex) ? '' : 'none';
    });
  }

  /* The reference repeats the same offer later on the page. One selected
     variant owns all copies; pack size is not cart quantity. */
  function syncReferenceVariant(box) {
    if (!box || !box.hasAttribute('data-reference-variant')) return;
    var id = getAttr(box, 'variant-id');
    var subscribing = !!box.dataset.sellingPlanId;
    document.querySelectorAll('[data-reference-variant]').forEach(function (item) {
      var selected = getAttr(item, 'variant-id') === id;
      item.classList.toggle('active', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
    document.querySelectorAll('[data-reference-offer]').forEach(function (offer) {
      offer.querySelector('input[name="id"]').value = id;
      var planInput = offer.querySelector('input[name="selling_plan"]');
      planInput.disabled = !subscribing;
      planInput.value = box.dataset.sellingPlanId || '';
      var nudge = offer.querySelector('[data-reference-nudge]');
      var heading = nudge.querySelector('[data-reference-savings]');
      var note = nudge.querySelector('[data-reference-saving-note]');
      var next = offer.querySelector('[data-reference-bottles="3"]');
      note.replaceChildren();
      if (box.dataset.referenceBottles === '1' && next) {
        heading.textContent = 'Could Be Better!';
        var amount = document.createElement('strong'); amount.textContent = next.dataset.savings;
        var title = document.createElement('strong'); title.textContent = next.dataset.offerTitle;
        note.append('Save ', amount, ' with ', title, '.');
        nudge.dataset.upgradeVariant = next.dataset.variantId;
        nudge.setAttribute('role', 'button'); nudge.tabIndex = 0;
      } else {
        heading.textContent = box.dataset.referenceBottles === '3' ? 'Great Choice!' : 'Best Value!';
        var saving = document.createElement('strong'); saving.textContent = box.dataset.savings;
        note.append('You save ', saving, ' compared with buying single packs.');
        delete nudge.dataset.upgradeVariant;
        nudge.setAttribute('role', 'status'); nudge.removeAttribute('tabindex');
      }
      var available = box.dataset.available === 'true';
      offer.querySelector(SEL.atcBtn).disabled = !available;
      offer.querySelector('[data-reference-atc-label]').textContent = available ? 'Add To Cart' : 'Unavailable';
      offer.querySelector('[data-reference-atc-price]').textContent = box.dataset.price;
      var compare = offer.querySelector('[data-reference-atc-compare]');
      compare.textContent = box.dataset.regularPrice;
      compare.hidden = box.dataset.compareVisible !== 'true';
      offer.querySelector('[data-reference-refills]').hidden = !subscribing;
      offer.querySelector('[data-reference-plan-name]').textContent = box.dataset.planName || '';
    });
  }
  function upgradeReferenceOffer(event) {
    var nudge = event.target.closest('[data-upgrade-variant]');
    if (!nudge || (event.type === 'keydown' && !['Enter', ' '].includes(event.key))) return;
    event.preventDefault();
    var target = nudge.closest('[data-reference-offer]').querySelector('[data-variant-id="' + nudge.dataset.upgradeVariant + '"]');
    syncReferenceVariant(target);
    if (event.type === 'keydown') target.focus();
  }
  document.addEventListener('click', upgradeReferenceOffer);
  document.addEventListener('keydown', upgradeReferenceOffer);

  /* ─── Read the current LP selection ─── */
  function getSelection() {
    var activeBox = document.querySelector(SEL.activeBox);
    if (!activeBox) return null;
    if (activeBox.hasAttribute('data-reference-variant') && activeBox.dataset.available !== 'true') return null;

    var variantId = getAttr(activeBox, 'variant-id');
    if (!variantId) return null;

    var qty = parseInt(getAttr(activeBox, 'quantity'), 10) || 1;
    var isSubscribe = !!document.querySelector(SEL.subBanner + '.active');
    var sellingPlanId = isSubscribe ? getAttr(activeBox, 'selling-plan-id') : '';
    if (activeBox.hasAttribute('data-reference-variant')) {
      var planInput = activeBox.closest('[data-reference-offer]').querySelector('input[name="selling_plan"]');
      sellingPlanId = planInput && !planInput.disabled ? planInput.value : '';
    }

    return {
      id: parseInt(variantId, 10),
      quantity: qty,
      selling_plan: sellingPlanId ? parseInt(sellingPlanId, 10) : undefined
    };
  }

  var cartRequestPending = false;

  /* ─── Add to cart via fetch, then straight to checkout ─── */
  function addToCart(btn) {
    if (cartRequestPending) return;
    var selection = getSelection();
    if (!selection) return;

    var body = {
      items: [{
        id: selection.id,
        quantity: selection.quantity
      }]
    };
    if (selection.selling_plan) {
      body.items[0].selling_plan = selection.selling_plan;
    }

    cartRequestPending = true;
    var goingToCheckout = false;
    var buttons = btn.closest('[data-reference-offer]')
      ? Array.prototype.slice.call(document.querySelectorAll('[data-reference-offer] .lp-ref-atc'))
      : [btn];
    document.querySelectorAll('.lp-atc-error').forEach(function (error) { error.remove(); });
    buttons.forEach(function (button) {
      button.classList.add('loading');
      button.setAttribute('aria-busy', 'true');
    });

    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }
        return data;
      });
    })
    .then(function (data) {
      // Add to cart goes straight to checkout; the drawer stays available from the cart icon.
      goingToCheckout = true;
      window.location.href = routeRoot + 'checkout';
    })
    .catch(function (err) {
      var existing = btn.parentNode.querySelector('.lp-atc-error');
      if (existing) existing.remove();

      var msg = err.message || 'Could not add to cart';
      var span = document.createElement('span');
      span.className = 'lp-atc-error';
      span.setAttribute('role', 'alert');
      span.textContent = msg;
      span.style.cssText = 'display:block;color:#c00;font-size:16px;margin-top:8px;text-align:center;';
      btn.parentNode.insertBefore(span, btn.nextSibling);
    })
    .finally(function () {
      if (goingToCheckout) return; // keep the spinner while the browser navigates
      cartRequestPending = false;
      buttons.forEach(function (button) {
        button.classList.remove('loading');
        button.removeAttribute('aria-busy');
      });
    });
  }

  /* ─── Variant box click ─── */
  document.addEventListener('keydown', function (e) {
    var box = e.target.closest('.rooted-bundle-options .variant-check');
    if (box && ['Enter', ' '].includes(e.key)) { e.preventDefault(); box.click(); }
  });
  document.addEventListener('click', function (e) {
    var box = e.target.closest(SEL.variantBox);
    if (!box || box.disabled) return;
    if (box.hasAttribute('data-reference-variant')) {
      syncReferenceVariant(box);
      return;
    }

    document.querySelectorAll(SEL.variantBox).forEach(function (b) {
      b.classList.remove('active'); b.setAttribute('aria-pressed', 'false');
    });
    box.classList.add('active'); box.setAttribute('aria-pressed', 'true');

    showPricesForTab(getAttr(box, 'tab'));
  });

  /* ─── Subscription toggle click ─── */
  document.addEventListener('click', function (e) {
    var item = e.target.closest(SEL.subItem);
    if (!item) return;

    setSubMode(item.classList.contains('subscription_item_sub'));
  });

  /* ─── Add to cart click ─── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(SEL.atcBtn);
    if (!btn) return;
    if (!btn.closest('.landing_page_product')) return;
    e.preventDefault();
    if (btn.disabled || btn.classList.contains('loading')) return;
    addToCart(btn);
  });

  /* ─── Init ─── */
  function init() {
    var hasSubscription = !!document.querySelector('.subscription_landing_page');
    setSubMode(hasSubscription);

    var activeBox = document.querySelector(SEL.activeBox);
    if (activeBox) {
      showPricesForTab(getAttr(activeBox, 'tab'));
      syncReferenceVariant(activeBox);
    }
  }

  // Script loads dynamically after DOM ready — call init immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
